/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */
/* global expocadfx:true */
// 'use strict'

expocadfx.MiniMap = function( miniMapContainer, offset) {
    var config = expocadfx.config;
    var data = expocadfx.fxData;
    var FxEvent = expocadfx.fxevent;
    var elemById = expocadfx.element.elementById;
    var util = expocadfx.util;
    
    var doc = document;
    var arBooths = data.boothGraphics;
    
    var canvas = null;
    var ctx = null;
    var i = 0;
    var MM_SCALE = (config.MINI_MAP_WIDTH - 4) / config.DRAWING_WIDTH;  // config.MINI_MAP_SCALE;
    var mmContainer = miniMapContainer;
    var mmBaseWidth = 0;        //  main window width - fp canvas plus offset - in drawing units
    var mmBaseHeight = 0;
    var mmLastX = 0;
    var mmLastY = 0;
    var mmMarkerX = 0;
    var mmMarkerY = 0;
    var mmMarkerW = 0;
    var mmMarkerH = 0;
    var mmUnScaledW = 0;
    var mmUnScaledH = 0;
    var mmUnScaledX = 0;
    var mmUnScaledY = 0;
    var mmMarkerDiv = doc.createElement( "div");
    var arMmCanvas = [];
	
    
    for( i = 0; i < 2; i++) {
        canvas = doc.createElement( "canvas");
        canvas.className = "unselectable";
        canvas.width = config.MINI_MAP_WIDTH - 4;
        canvas.height = Math.round( canvas.width * ( config.DRAWING_HEIGHT / config.DRAWING_WIDTH));
        ctx = canvas.getContext( "2d");
        ctx.textAlign = "center";
        ctx.scale( MM_SCALE, MM_SCALE);
        arMmCanvas.push( { canvas:canvas, ctx:ctx});

        mmContainer.appendChild( canvas);
    }

    mmBaseWidth = config.DRAWING_WIDTH + 2 * offset.x;  // unscaled size
    mmBaseHeight = config.DRAWING_HEIGHT + 2 * offset.y;
        //  calculate size of marker div and location
    mmUnScaledW = canvas.width * mmBaseWidth / config.DRAWING_WIDTH;
    mmUnScaledH = canvas.height * mmBaseHeight / config.DRAWING_HEIGHT;
    mmUnScaledX = -1 * offset.x * MM_SCALE;
    mmUnScaledY = -1 * offset.y * MM_SCALE;

    mmMarkerDiv.setAttribute( "id", "mmMarkerDiv");
    mmMarkerDiv.style.width = mmUnScaledW + "px";
    mmMarkerDiv.style.height = mmUnScaledH + "px";
    mmMarkerDiv.style.top = mmUnScaledY + "px";
    mmMarkerDiv.style.left = mmUnScaledX + "px";

    mmContainer.appendChild( mmMarkerDiv);


	function resize( offset) {
		mmBaseWidth = config.DRAWING_WIDTH + 2 * offset.x;
		mmBaseHeight = config.DRAWING_HEIGHT + 2 * offset.y;
        //   current marker size
        mmUnScaledW = canvas.width * mmBaseWidth / config.DRAWING_WIDTH;
        mmUnScaledH = canvas.height * mmBaseHeight / config.DRAWING_HEIGHT;
        
        mmMarkerDiv.style.width = mmUnScaledW + "px";
        mmMarkerDiv.style.height = mmUnScaledH + "px";
    }
    
			//  CALLED FROM    fp.drawFloorPlan();
    function setupMiniMap() {
        var numPavilions = data.pavilions.length;
        var numBooths = arBooths.length;
        var i = 0;
        
        for( i = 0; i < numPavilions; i++) {
            drawBooth( data.pavilions[i], arMmCanvas[1].ctx);
        }
        
        for( i = 0; i < numBooths; i++) {
            drawBooth( arBooths[i], arMmCanvas[1].ctx);
        }
        
        mmMarkerW = mmBaseWidth;
        mmMarkerH = mmBaseHeight;
        
        mmMarkerX = ( config.DRAWING_WIDTH / 2) - 0.5 * mmMarkerW;
        mmMarkerY = ( config.DRAWING_HEIGHT / 2) - 0.5 * mmMarkerH;
        
        doc.addEventListener( "Floor_Plan_Change", floorPlanChangeHandler);
        
        if( config.bMiniMapOpen) {
            elemById( "minimap").style.display = "block";
        }
    }
    
    function enableNavigation() {
        mmMarkerDiv.addEventListener( "mousedown", mmMouseDown);
        mmMarkerDiv.addEventListener( "touchstart", mmTouchStart);
        util.addClass( mmMarkerDiv, "mm-nav");
            
    }
    
    function disableNavigation() {
        mmMarkerDiv.removeEventListener( "mousedown", mmMouseDown);
        mmMarkerDiv.removeEventListener( "touchstart", mmTouchStart);
        util.removeClass( mmMarkerDiv, "mm-nav");
    }
    
    function floorPlanChangeHandler( evt) {
        updateMiniMap( evt.data.ratio, evt.data.x, evt.data.y);
    }
    
    function updateMiniMap( ratio, centerX, centerY) {
        // ratio of initial scale to current scale
        if( mmMarkerDiv && arMmCanvas.length > 0) {
                //  size of rect must reflect the size of browser window
            mmMarkerW = mmBaseWidth * ratio * MM_SCALE;
            mmMarkerH = mmBaseHeight * ratio * MM_SCALE;
          
            mmMarkerW = Math.max( mmUnScaledW * ratio, 85);
            mmMarkerH = Math.max( mmUnScaledH * ratio, 46);

            mmMarkerX = (centerX * MM_SCALE) - (0.5 * mmMarkerW);
            mmMarkerY = (centerY * MM_SCALE) - (0.5 * mmMarkerH);
            
            mmMarkerDiv.style.width = mmMarkerW + "px";
            mmMarkerDiv.style.height = mmMarkerH + "px";

            mmMarkerDiv.style.left = mmMarkerX + "px";
            mmMarkerDiv.style.top = mmMarkerY + "px";
        }
    }
		
    function drawBooth( obj, context) {         // pavilions, graphics, and booths in firefox
        var i;
        if( !obj.path || obj.type === "C" || obj.type === "A") {
            return;
        }
        var len = obj.path.length;
        context.save();
        context.globalAlpha = obj.opacity;
        context.strokeStyle = obj.strokeColor;
        context.lineWidth = obj.linewidth/2;
        context.fillStyle = obj.fillColor;
        context.beginPath();
        context.moveTo( obj.path[0].x, obj.path[0].y);
        for( i = 1; i < len; i += 1) {
            context.lineTo( obj.path[i].x, obj.path[i].y);
        }
        if( obj.type !== "F") {
            context.closePath();
            if( obj.type === "T") {
                context.fillStyle = obj.fillColor;
            }
            context.fill();
            context.stroke();
        }
        else {
            context.stroke();
        }
        context.restore();
    }
    
    function addBuildingImage( image) {
        arMmCanvas[0].ctx.drawImage( image, 0, 0, config.DRAWING_WIDTH,
                                         config.DRAWING_HEIGHT);
    }
    
//    if ( window.PointerEvent) {
    
    function mmMouseDown( evt) {
        util.addClass( mmMarkerDiv, "mm-down");
        mmContainer.addEventListener( "mousemove", mmMouseMove);
        mmContainer.addEventListener( "mouseup", mmMouseUp);
        mmContainer.addEventListener( "mouseout", mmMouseUp);
        mmLastX = evt.clientX;
        mmLastY = evt.clientY;
    }
    
    function mmMouseMove( evt) {
        var dx = ( mmLastX - evt.clientX) / MM_SCALE;
        var dy = ( mmLastY - evt.clientY) / MM_SCALE;
        
        doc.dispatchEvent( new FxEvent( "Mini_Map_Change", { x:dx, y:dy}));
        
        mmLastX = evt.clientX;
        mmLastY = evt.clientY;
    }
    
    function mmMouseUp() {
        util.removeClass( mmMarkerDiv, "mm-down");
        mmContainer.removeEventListener( "mousemove", mmMouseMove);
        mmContainer.removeEventListener( "mouseup", mmMouseUp);
        mmContainer.removeEventListener( "mouseout", mmMouseUp);
    }
    
    function mmTouchStart( evt) {
        evt.preventDefault();
        util.addClass( mmMarkerDiv, "mm-down");
        mmContainer.addEventListener( "touchmove", mmTouchMove);
        mmContainer.addEventListener( "touchend", mmTouchEnd);
        mmLastX = evt.touches[0].clientX;
        mmLastY = evt.touches[0].clientY;
    }
    
    function mmTouchMove( evt) {
        var dx = ( mmLastX - evt.touches[0].clientX) / MM_SCALE;
        var dy = ( mmLastY - evt.touches[0].clientY) / MM_SCALE;
        
        doc.dispatchEvent( new FxEvent( "Mini_Map_Change", { x:dx, y:dy}));
        
        mmLastX = evt.touches[0].clientX;
        mmLastY = evt.touches[0].clientY;
    }
    
    function mmTouchEnd() {
        util.removeClass( mmMarkerDiv, "mm-down");
        mmContainer.removeEventListener( "touchmove", mmTouchMove);
        mmContainer.removeEventListener( "touchend", mmTouchEnd);
    }
	
	
    return {
        addBuilding: addBuildingImage,
        disableNavigation: disableNavigation,
        enableNavigation: enableNavigation,
		resize: resize,
		setup: setupMiniMap
	};
};